import React, { useState } from 'react';
import { Props } from '../container';
import { Box, Grid, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ReportingBatchReportView } from './ReportingBatchReportView';
import { downloadCustomCsv, WO2ToggleSwitch } from 'src/common';
import { buildReportParametersCsv } from '../store/utils';
import WO2Button from 'src/common/components/button/Button';
import { REPORTING_REPORTS_KEY } from '../../constants';
import { ReportFormatOption } from 'src/features/clients/client/reportsV2/components/ReportFormatOption';

export interface ReportingBatchDetailsProps extends Props {
  initiateBulk: (currentPage: number, currentPageSize: number, allRecords: boolean, batchRecords?: number[]) => void;
  changeTab: (value: string) => void;
}

export const ReportingBatchDetails = (props: ReportingBatchDetailsProps) => {
  const [generating, setGenerating] = useState<boolean>(false);
  const [fullReports, setFullReports] = useState<boolean>(false);

  const downloadParameters = () => {
    const params = props.batch.bulkReport.reportParameters;
    if (!params) return;
    downloadCustomCsv(buildReportParametersCsv(params), `${props.batch.bulkReport.id}`);
  };

  const initialBulk = () => {
    setGenerating(true);
    props.initiateBulk(-1, -1, true);

    setTimeout(() => {
      props.changeTab(REPORTING_REPORTS_KEY);
      setGenerating(false);
    }, 3000);
  };

  return (
    <Grid container spacing={2} direction="column">
      <Grid item container spacing={2} alignItems="center">
        <Grid item>
          <ReportFormatOption
            format={props.batch.bulkReport.reportParameters?.reportFormat}
            setReportFormat={props.setReportFormat}
            hasClientEditAdminOnlyPermission={props.hasClientEditAdminOnly}
            isDisplayOnly={true} />
        </Grid>
        {props.hasClientEditAdminOnly && (
          <Grid item>
            <Box display="flex" alignItems="center">
              <WO2ToggleSwitch
                checked={fullReports}
                onChange={(e) => setFullReports(e.target.checked)}
                color="primary"
              />
              <Typography variant="h4">Full Reports</Typography>
            </Box>
          </Grid>
        )}
        <Grid item flex={1} />
        <Grid item display="none">
          <WO2Button variant="outlined" onClick={downloadParameters}>
            Download Parameters
          </WO2Button>
        </Grid>
        {!props.batch.bulkReport.scheduleInstanceDetails && (
          <Grid item>
            <LoadingButton
              loading={props.initiateBulkRequestProgress.isLoading || generating}
              variant="contained"
              onClick={initialBulk}
            >
              Generate
            </LoadingButton>
          </Grid>
        )}
      </Grid>
      <ReportingBatchReportView
        fullReports={fullReports}
        request={props.batch.bulkReport.reportParameters}
        {...props}
      />
    </Grid>
  );
};
